import useLocalStorage, { getStorageValue, removeStorageValue } from "@/localStorage/localStorage";
import { useQueryClient } from "@tanstack/react-query";
import { hasPermission, User } from "@/user/user";
import { InternalAxiosRequestConfig } from "axios";

const ANONYMIZE_KEY = "anonymize";

export const ANONYMIZE_USER_PERMISSION = "dashboard.anonymize"

export const ANONYMIZE_HEADER = "X-Anonymize";

export const useAnonymize = () => {
  const queryClient = useQueryClient();
  const [anonymize, setAnonymize] = useLocalStorage<boolean>(ANONYMIZE_KEY, false);

  const setAnonymizeWithInvalidation = (value: boolean) => {
    setAnonymize(value);
    queryClient.invalidateQueries();
  };

  return [anonymize, setAnonymizeWithInvalidation] as const;
};

export const shouldAnonymize = () => {
  return getStorageValue<boolean>(ANONYMIZE_KEY, false);
}

export const optionallyAnonymizeRequest = (request: InternalAxiosRequestConfig) => {
  if (shouldAnonymize() && request.method !== 'options') {
    request.headers[ANONYMIZE_HEADER] = 'true';
  }
}

export const cleanupAnonymizeValueIfNoPermissions = (user: User) => {
  if (!hasPermission(user, ANONYMIZE_USER_PERMISSION)) {
    removeStorageValue(ANONYMIZE_KEY);
  }
}
